import React from 'react';
import { Music, Globe, Tag } from 'lucide-react';
import type { Song } from '../types';

interface SongListProps {
  songs: Song[];
  onSongSelect: (song: Song) => void;
}

export function SongList({ songs, onSongSelect }: SongListProps) {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {songs.map((song) => (
        <div
          key={song.id}
          className="group relative rounded-lg border border-gray-200 p-4 hover:border-purple-500 transition-colors cursor-pointer"
          onClick={() => onSongSelect(song)}
        >
          <div className="flex items-center gap-3 mb-2">
            <Music className="h-5 w-5 text-purple-600" />
            <h3 className="font-medium text-gray-900">{song.title}</h3>
          </div>
          <div className="space-y-1 text-sm text-gray-500">
            <div className="flex items-center gap-2">
              <span>{song.artist}</span>
            </div>
            <div className="flex items-center gap-2">
              <Tag className="h-4 w-4" />
              <span>{song.genre}</span>
            </div>
            <div className="flex items-center gap-2">
              <Globe className="h-4 w-4" />
              <span>{song.language}</span>
            </div>
          </div>
          <div className="absolute inset-0 rounded-lg ring-2 ring-purple-500 ring-offset-2 opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>
      ))}
    </div>
  );
}